import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { filter, map } from 'rxjs/operators';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { isNotNil } from '../../../../../helpers/is-not-nil';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read-helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShLongInputFieldComponent } from '../long-input-field/long-input-field.component';

@Component({
    selector: 'sh-frames-field',
    templateUrl: './frames-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShFramesInputFieldComponent extends ShLongInputFieldComponent {
    constructor(fieldHelper: FieldReadHelper) {
        super(fieldHelper);
    }

    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const value = this.isBatchEdit
            ? BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition)
            : this.fieldHelper.getMergedFramesFieldValue(profileField.FieldDefinition, records);
        control.setValue(value);

        control.statusChanges
            .pipe(
                map(() => control.errors),
                filter(isNotNil),
                map(errors => Object.keys(errors)),
                filter(errorKeys => errorKeys.includes('min')),
                map(() => this.translateService.instant('errors.min', { limit: 0 }))
            )
            .subscribe(this.errorMsg$);
    }
}
